@if (tags?.length) {
  <div class="ps-5 ms-4">
    <div class="d-flex">
      @for (tag of tags; track $index) {
        @if (tag === ShiftAssignmentTags.HotelNecessary) {
          @if (
            'portal-shift-assignment-modal-hotel-tag' | featureFlagPure | async
          ) {
            <ng-container
              [ngTemplateOutlet]="tagElement"
              [ngTemplateOutletContext]="{ tag }"
            ></ng-container>
          }
        } @else {
          <ng-container
            [ngTemplateOutlet]="tagElement"
            [ngTemplateOutletContext]="{ tag }"
          ></ng-container>
        }
      }
    </div>
  </div>
}

<ng-template #tagElement let-tag="tag">
  <nz-tag
    class="rounded-1 m-0 ms-1 mb-1"
    [nzColor]="
      tag === ShiftAssignmentTags.StartLate
        ? 'red'
        : tag === ShiftAssignmentTags.BestSmartScore
          ? 'blue'
          : tag === ShiftAssignmentTags.BestPrefScore
            ? 'green'
            : tag === ShiftAssignmentTags.TransferNecessary
              ? 'yellow'
              : ''
    "
  >
    {{ 'page.shift_assignment.tags.' + tag | translate }}
  </nz-tag>
</ng-template>
